
var Shop = function() {
	$(function() {

		$(document.body).on("click", '.q-update', function (e) {
			e.preventDefault();

			var productId = $(this).data('product-id');
			var action = $(this).data('action');
			var currentQuantity = parseInt($('#product-quantity-'+productId).val());

			if (action === 'minus' && currentQuantity === 0) {
				return false;
			}

			if (action === 'minus' && currentQuantity >= 1) {
				newQuantity = currentQuantity-1;
			} else {
				newQuantity = currentQuantity+1;
			}

			$('#product-quantity-'+productId).val(newQuantity);

			// reset btn from green to yellow
			var btn = $('#product-'+productId).find('.btn');

			btn.removeClass('btn-green');
			btn.find('i.icon-status').removeClass('fa-check').addClass('fa-plus');

			return false;
		});

		$(document.body).on("click", '.add-to-cart', function (e) {
			e.preventDefault();

			if ($('#popup-modal-has-other-cart-items').length) {
				$('#popup-modal-has-other-cart-items').modal('show');

			} else {

				//var action = $(this).data('action');
				var action    = 'add';
				var productId = $(this).parent().data('product-id');
				var quantity  = parseInt($('#product-quantity-'+productId).val());

				// if (quantity === 0) {
				// 	quantity = 1;
				// }

				updateCart(action, productId, quantity);
			}
		});
	});

	return this;
}();


function updateCart(action, productId, quantity) {
	request_products = $.post('/site/ajax/update_cart.php?product_id='+productId+'&quantity='+quantity, $(this).serializeArray(), function(data) {
		console.log(data);
		//$results.html(data['product_list']).removeClass('loading');
		if (data['total_items'] !== '') {
			$('.counter').html(data['total_items']);
			$('.counter').removeClass('d-none');
			$('#product-quantity-'+productId).val(quantity);

			$('#product-'+productId).find('.icon-status').removeClass('fa-plus');
			$('#product-'+productId).find('.icon-status').addClass('fa-check');
			$('#product-'+productId).find('.btn').addClass('btn-green');
		}
	});
}
